export const DEFAULT_OPTIONS: google.maps.MapOptions = {
  gestureHandling: "greedy",
  streetViewControl: false,
  fullscreenControl: false,
  mapTypeControl: false,
  maxZoom: 16,
}
